export default __webpack_public_path__ + "static/media/bxs-error.3e95e741.svg";